class ProductPage {
	constructor() {
		this.selectors = {
			document: document,
			body: 'body',
			share_product : '.js-share-product',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {	
		$(document).ready(() => {
			// size-color conection logic in dependency of product's feature
			let color = false;
			let size = false;
			if ($('.js-info-colors').length) color = $('.js-info-colors').length;
			if ($('.js-info-sizes').length) size = $('.js-info-sizes').length;       
			switch (true) {
				case (color && !size): 
					// console.log('color')
					import('./color.js');					
					break;
				case (size && !color): 
					// console.log('size')
					import('./size.js');
					break;
				case ((size && color) === 1): 
					// console.log('color and size')
					import('./size-color.js');					
					break;           
			};   

			$(document).on('click', e => {							
				if ($(e.target).is('.js-share-product .icon1-share')) {
					e.preventDefault();
					$('#js-share-block').toggleClass('opened');					
				} else if (!(($(e.target).closest("#js-share-block").length > 0 ) || ($(e.target).closest(".js-share-product .icon1-share").length > 0))) {
					$('#js-share-block').removeClass('opened');
				}
			});
			$(document).on('click', '.product_info_share_link', function(e){
				e.preventDefault();
				const $this = $(this);
				window.open($this.attr('href').replace('#url',window.location.href),"social", "width=600,height=450");
			});
		});			
  	}
}
new ProductPage()